import React from 'react';
import { motion } from 'framer-motion';
import tw from 'twin.macro';
import styled from 'styled-components';
import { css } from 'styled-components/macro'; // eslint-disable-line
import { Container, ContentWithPaddingXl } from 'components/misc/Layouts.js';
import { SectionHeading } from 'components/misc/Headings.js';
import { PrimaryButton as PrimaryButtonBase } from 'components/misc/Buttons.js';
import { ReactComponent as SvgDecoratorBlob1 } from 'images/svg-decorator-blob-5.svg';
import { ReactComponent as SvgDecoratorBlob2 } from 'images/svg-decorator-blob-7.svg';
import { useNavigate } from 'react-router-dom';

const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;
const Header = tw(SectionHeading)``;

const CategoriesGrid = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 sm:pr-10 md:pr-6 lg:pr-12`;
const Card = tw(motion.div)`bg-gray-200 rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0 cursor-pointer`;
const CardImageContainer = styled.div`
	${(props) => css`
		background-image: url('${props.imageSrc}');
	`}
	${tw`h-56 xl:h-64 bg-center bg-cover relative rounded-t`}
`;

const CardHoverOverlay = styled(motion.div)`
	background-color: rgba(255, 255, 255, 0.5);
	${tw`absolute inset-0 flex justify-center items-center`}
`;
const CardButton = tw(PrimaryButtonBase)`text-sm`;

const CardText = tw.div`p-4 text-gray-900`;
const CardTitle = tw.h5`text-lg font-semibold group-hover:text-primary-500`;
const CardContent = tw.p`mt-1 text-sm font-medium text-gray-600`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
	${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
	${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;

export default ({
	heading = 'Nuestras mejores categorías',
	categories = [
		{
			imageSrc:
				'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80',
			title: 'Starters',
			description: 'A variety of appetizers and starters.',
			url: '/categoria/starters',
		},
		{
			imageSrc:
				'https://images.unsplash.com/photo-1432139555190-58524dae6a55?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80',
			title: 'Main',
			description: 'Delicious main course options.',
			url: '/categoria/main',
		},
		{
			imageSrc:
				'https://images.unsplash.com/photo-1476224203421-9ac39bcb3327??ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80',
			title: 'Soup',
			description: 'Warm and comforting soups.',
			url: '/categoria/soup',
		},
		{
			imageSrc:
				'https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80',
			title: 'Desserts',
			description: 'Sweet treats and desserts.',
			url: '/categoria/desserts',
		},
	],
}) => {
	const navigate = useNavigate();

	const handleCardClick = (url) => {
		navigate(url);
	};

	return (
		<Container>
			<ContentWithPaddingXl>
				<HeaderRow>
					<Header>{heading}</Header>
				</HeaderRow>

				<CategoriesGrid>
					{categories.map((category, index) => (
						<CardContainer key={index}>
							<Card onClick={() => handleCardClick(category.url)} className="group">
								<CardImageContainer imageSrc={category.imageSrc}>
									<CardHoverOverlay
										initial={{ opacity: 0 }}
										whileHover={{ opacity: 1 }}
										transition={{ duration: 0.3 }}
									>
										<CardButton>Ver {category.title}</CardButton>
									</CardHoverOverlay>
								</CardImageContainer>
								<CardText>
									<CardTitle>{category.title}</CardTitle>
									<CardContent>{category.description}</CardContent>
								</CardText>
							</Card>
						</CardContainer>
					))}
				</CategoriesGrid>
			</ContentWithPaddingXl>
			<DecoratorBlob1 />
			<DecoratorBlob2 />
		</Container>
	);
};
